import { StrictMode } from 'react';
import './index.css';

import { createRoot } from 'react-dom/client';

import { GoogleOAuthProvider } from '@react-oauth/google';

import App from './App.tsx';
import { LangProvider } from './provider/LangProvider.tsx';
import { SettingsProvider } from './provider/SettingsProvider.tsx';
import { NotistackProvider } from './provider/SnakbarProvider.tsx';

const googleClientId = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID as string;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <SettingsProvider>
        <LangProvider>
          <NotistackProvider />
          <App />
        </LangProvider>
      </SettingsProvider>
    </GoogleOAuthProvider>
  </StrictMode>
);
